import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';

const getInitialState = (areaId, prioridadDefault, estadoDefault) => ({
    area_id: areaId || '',
    nombre: '',
    fecha_inico: '',
    fecha_fin: '',
    estado: estadoDefault != null ? String(estadoDefault) : '',
    responsable: '',
    prioridad: prioridadDefault != null ? String(prioridadDefault) : '',
});

const ModalTareaGantt = ({
    isOpen,
    tarea,
    onSave,
    onClose,
    areaId,
    areasCatalog = [],
    prioridadCatalog = [],
    estadosCatalog = [],
    usuarios = [],
    currentUserNombre = '',
}) => {
    const [formData, setFormData] = useState(getInitialState(areaId, prioridadCatalog[0]?.tipo_id, estadosCatalog[0]?.tipo_id));

    useEffect(() => {
        if (isOpen) {
            if (tarea) {
                setFormData({
                    id: tarea.id,
                    area_id: tarea.area_id,
                    nombre: tarea.nombre || '',
                    fecha_inico: tarea.fecha_inico ? tarea.fecha_inico.split('T')[0] : '',
                    fecha_fin: tarea.fecha_fin ? tarea.fecha_fin.split('T')[0] : '',
                    estado: tarea.estado != null ? String(tarea.estado) : '',
                    responsable: tarea.responsable || '',
                    prioridad: tarea.prioridad != null ? String(tarea.prioridad) : '',
                });
            } else {
                const initialState = getInitialState(areaId, prioridadCatalog[0]?.tipo_id, estadosCatalog[0]?.tipo_id);
                setFormData({
                    ...initialState,
                    responsable: currentUserNombre,
                });
            }
        }
    }, [tarea, isOpen, areaId, prioridadCatalog, estadosCatalog, currentUserNombre]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async () => {
        if (!formData.area_id) {
            alert('Por favor, seleccione el área.');
            return;
        }
        if (!formData.nombre.trim()) {
            alert('Por favor, ingrese el nombre de la tarea.');
            return;
        }
        if (!formData.fecha_inico) {
            alert('Por favor, ingrese la fecha de inicio.');
            return;
        }
        if (!formData.fecha_fin) {
            alert('Por favor, ingrese la fecha de fin.');
            return;
        }
        if (!formData.responsable) {
            alert('Por favor, seleccione el responsable.');
            return;
        }
        if (!formData.prioridad) {
            alert('Por favor, seleccione la prioridad.');
            return;
        }
        if (!formData.estado) {
            alert('Por favor, seleccione el estado.');
            return;
        }

        const dataToSave = {
            ...formData,
            area_id: parseInt(formData.area_id),
            estado: parseInt(formData.estado),
            prioridad: String(formData.prioridad),
        };

        try {
            await onSave(dataToSave);
            onClose(true);
        } catch (error) {
            console.error('Error al guardar la tarea:', error);
        }
    };

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="lg">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>{tarea ? 'EDITAR TAREA GANTT' : 'NUEVA TAREA GANTT'}</h1>
                    <Button className="close-btn" onClick={() => onClose()}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <Form className="fila" onSubmit={(e) => e.preventDefault()}>
                        <FormGroup>
                            <Label>Actividades: <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                                className="form-control"
                                type="text"
                                name="nombre"
                                value={formData.nombre}
                                onChange={handleChange}
                                placeholder="Nombre de la tarea"
                                maxLength={60}
                            />
                            <small style={{ color: '#888', float: 'right' }}>{formData.nombre.length}/60</small>
                        </FormGroup>

                        <FormGroup>
                            <Label>Responsable: <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                                className="form-control"
                                type="select"
                                name="responsable"
                                value={formData.responsable}
                                onChange={handleChange}
                            >
                                <option value="">Seleccione un responsable...</option>
                                {currentUserNombre ? (
                                    <option value={currentUserNombre}>{currentUserNombre}</option>
                                ) : (
                                    usuarios.map(u => (
                                        <option key={u.usuario_id} value={u.nombre_completo}>{u.nombre_completo}</option>
                                    ))
                                )}
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label>Fecha Inicio: <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                                className="form-control"
                                type="date"
                                name="fecha_inico"
                                value={formData.fecha_inico}
                                onChange={handleChange}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Fecha Fin: <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                                className="form-control"
                                type="date"
                                name="fecha_fin"
                                value={formData.fecha_fin}
                                onChange={handleChange}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Prioridad:</Label>
                            <Input
                                className="form-control"
                                type="select"
                                name="prioridad"
                                value={formData.prioridad}
                                onChange={handleChange}
                            >
                                <option value="">Seleccione...</option>
                                {prioridadCatalog.map(p => (
                                    <option key={p.tipo_id} value={String(p.tipo_id)}>{p.descripcion}</option>
                                ))}
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label>Estado:</Label>
                            <Input
                                className="form-control"
                                type="select"
                                name="estado"
                                value={formData.estado}
                                onChange={handleChange}
                            >
                                <option value="">Seleccione...</option>
                                {estadosCatalog.map(e => (
                                    <option key={e.tipo_id} value={String(e.tipo_id)}>{e.descripcion}</option>
                                ))}
                            </Input>
                        </FormGroup>
                    </Form>
                    <FormGroup>
                        <div className="button-container">
                            <Button
                                className="button-custom"
                                onClick={handleSubmit}
                            >
                                {tarea ? 'ACTUALIZAR' : 'REGISTRAR'}
                            </Button>
                        </div>
                    </FormGroup>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalTareaGantt;
